<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
    <g>
      <path
        d="M11.159,33.807C2.153,30.306-2.307,20.166,1.193,11.157C4.696,2.153,14.837-2.309,23.841,1.195
		c9.006,3.498,13.466,13.644,9.966,22.646C30.304,32.849,20.163,37.307,11.159,33.807"
      />
      <g>
        <g id="XMLID_12_">
          <g>
            <path
              fill="#FFFFFF"
              d="M11.658,11.526l-0.834,3.48c-0.185,0.769-0.966,1.391-1.746,1.391H8.372
					c-0.778,0-1.556-0.622-1.734-1.391l-0.808-3.48c-0.179-0.769,0.838-1.391,2.27-1.391h1.298
					C10.83,10.136,11.841,10.758,11.658,11.526z"
            />
            <ellipse fill="#FFFFFF" cx="8.744" cy="7.7" rx="1.727" ry="1.739" />
          </g>
        </g>
        <g id="XMLID_11_">
          <g>
            <ellipse
              fill="#FFFFFF"
              cx="26.273"
              cy="7.693"
              rx="1.719"
              ry="1.732"
            />
            <path
              fill="#FFFFFF"
              d="M25.903,16.354c-0.775,0-1.549-0.622-1.726-1.388l-0.807-3.462c-0.178-0.766,0.835-1.387,2.262-1.387
					h1.292c1.426,0,2.433,0.621,2.25,1.387l-0.829,3.462c-0.185,0.766-0.962,1.388-1.737,1.388H25.903z"
            />
          </g>
        </g>
        <g id="XMLID_10_">
          <g>
            <path
              fill="#FFFFFF"
              d="M14.604,24.601c-0.178-0.766,0.833-1.386,2.26-1.386h1.292c1.427,0,2.434,0.62,2.25,1.386l-0.829,3.463
					c-0.185,0.766-0.962,1.386-1.737,1.386h-0.703c-0.775,0-1.55-0.62-1.728-1.386L14.604,24.601z"
            />
            <ellipse
              fill="#FFFFFF"
              cx="17.505"
              cy="20.789"
              rx="1.719"
              ry="1.733"
            />
          </g>
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M22.608,28.503c-0.42,0-0.828-0.217-1.054-0.606c-0.337-0.584-0.138-1.323,0.443-1.662
				c2.616-1.515,4.291-4.212,4.481-7.218c0.042-0.669,0.622-1.178,1.29-1.136c0.671,0.044,1.18,0.62,1.138,1.292
				c-0.241,3.821-2.37,7.246-5.691,9.166C23.023,28.449,22.815,28.503,22.608,28.503z"
          />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M12.336,28.467c-0.21,0-0.423-0.054-0.616-0.168c-3.267-1.92-5.368-5.317-5.619-9.088
				c-0.046-0.671,0.462-1.249,1.132-1.295c0.672-0.044,1.25,0.463,1.294,1.136c0.199,2.964,1.853,5.637,4.426,7.148
				c0.579,0.342,0.773,1.088,0.433,1.666C13.158,28.252,12.753,28.467,12.336,28.467z"
          />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M21.169,10.124c-0.145,0-0.294-0.026-0.438-0.081c-1.027-0.396-2.115-0.598-3.229-0.598
				s-2.198,0.199-3.226,0.595c-0.627,0.241-1.33-0.071-1.571-0.7c-0.241-0.627,0.072-1.33,0.699-1.571
				c1.307-0.502,2.686-0.755,4.098-0.755c1.414,0,2.794,0.253,4.103,0.758c0.628,0.242,0.94,0.944,0.699,1.572
				C22.119,9.826,21.658,10.124,21.169,10.124z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
